import React, { Suspense } from 'react';
import { renderRoutes } from 'react-router-config';
import PropTypes from 'prop-types';
import useStyles from './styles';
import { LinearProgress } from '@material-ui/core';

const Auth = props => {
  const { route } = props;

  const classes = useStyles();

  return (
    <div className={classes.content}>
      <div>
        <Suspense fallback={<LinearProgress/>}>{renderRoutes(route.routes)}</Suspense>
      </div>
    </div>
  );
};

Auth.propTypes = {
  route: PropTypes.object,
};

export default Auth;
